import React from 'react'
import cx from 'classnames'

import styles from './styles.module.css'

export interface ChartLegendItem {
  key: string
  label: string
  type?: 'line' | 'square'
  color: string
  dashed?: boolean
  border?: boolean
}

interface ChartLegendProps {
  items: ChartLegendItem[]
  hiddenKeys: Set<string>
  onToggle: (key: string) => void
  className?: string
}

const ChartLegend: React.FC<ChartLegendProps> = ({
  items,
  hiddenKeys,
  onToggle,
  className
}) => (
  <ul className={cx(className)}>
    {items.map(({ key, label, type = 'line', color, dashed, border }) => {
      const hidden = hiddenKeys.has(key)
      return (
        <li key={key}>
          <button
            type="button"
            aria-label={`${hidden ? 'Mostrar' : 'Ocultar'} ${label}`}
            aria-pressed={!hidden}
            className={cx(styles.legendItem, { [styles.legendItemHidden]: hidden })}
            onClick={() => onToggle(key)}
          >
            {type === 'square' ? (
              <span
                className={styles.legendSquare}
                style={{
                  backgroundColor: color,
                  border: border ? '1px solid #d1d5db' : undefined
                }}
                aria-hidden="true"
              />
            ) : (
              <svg
                width="24"
                height="4"
                viewBox="0 0 24 4"
                aria-hidden="true"
                focusable="false"
              >
                <line
                  x1="0"
                  y1="2"
                  x2="24"
                  y2="2"
                  stroke={color}
                  strokeWidth={2}
                  strokeDasharray={dashed ? '6 4' : undefined}
                />
              </svg>
            )}
            <span>{label}</span>
          </button>
        </li>
      )
    })}
  </ul>
)

export default ChartLegend
